import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * RedirectComponent - Handles post-login redirect with fallbacks
 * Checks session validity and redirects to appropriate dashboard
 */
export function RedirectAfterLogin() {
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleRedirect = async () => {
      try {
        // Get stored data
        const sessionToken = localStorage.getItem('session_token');
        const userEmail = localStorage.getItem('user_email');
        const userRole = localStorage.getItem('user_role');

        console.log('🔄 RedirectAfterLogin - Checking session...');
        console.log('Session token exists:', !!sessionToken);
        console.log('User email exists:', !!userEmail);
        console.log('User role:', userRole);

        if (!sessionToken || !userEmail) {
          console.warn('⚠️ No session/user data found, redirecting to login');
          navigate('/login', { replace: true });
          return;
        }

        console.log('✅ Session found, redirecting to dashboard');

        // Determine redirect URL based on role
        const redirectUrl = userRole === 'admin' ? '/admin-dashboard' : '/user-dashboard';
        console.log('Redirecting to:', redirectUrl);

        // Use React Router navigate
        navigate(redirectUrl, { replace: true });
        setLoading(false);
      } catch (err) {
        console.error('Redirect error:', err);
        setError(err.message || 'Redirect failed');
        setLoading(false);
        
        // Fallback - try redirect anyway
        setTimeout(() => {
          const userEmail = localStorage.getItem('user_email');
          const userRole = localStorage.getItem('user_role');
          if (userEmail) {
            const redirectUrl = userRole === 'admin' ? '/admin-dashboard' : '/user-dashboard';
            navigate(redirectUrl, { replace: true });
          } else {
            navigate('/login', { replace: true });
          }
        }, 1000);
      }
    };

    handleRedirect();
  }, [navigate]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Redirecting...</span>
          </div>
          <p className="mt-3">Redirecting to your dashboard...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <div className="text-center">
          <div className="alert alert-danger">
            <h4>Redirect Error</h4>
            <p>{error}</p>
            <p>Attempting automatic redirect...</p>
          </div>
        </div>
      </div>
    );
  }

  return null;
}

export default RedirectAfterLogin;
